var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-75.711 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1137",
    "data-name": "Rectangle 1137",
    width: 32,
    height: 32,
    transform: "translate(75.711 -4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2321",
    "data-name": "Group 2321",
    transform: "translate(83.711 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4560",
    "data-name": "Path 4560",
    d: "M99.4,209.3a.935.935,0,0,0-.923.923v1.846a6.462,6.462,0,0,1-12.924,0v-1.846a.923.923,0,0,0-1.846,0v1.846a8.307,8.307,0,0,0,7.385,8.25v1.9H87.4a.923.923,0,0,0,0,1.846h9.231a.923.923,0,0,0,0-1.846H92.942v-1.9a8.307,8.307,0,0,0,7.385-8.25v-1.846a.936.936,0,0,0-.923-.923Z",
    transform: "translate(-83.711 -200.067)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4561",
    "data-name": "Path 4561",
    d: "M169.873,8.986h-2.44v1.693h2.44a.675.675,0,1,1,0,1.35h-2.439a4.614,4.614,0,0,0,9.228,0h-2.354a.675.675,0,1,1,0-1.35h2.355V8.986h-2.355a.675.675,0,1,1,0-1.35h2.355v-1.8h-2.355a.675.675,0,1,1,0-1.35h2.349a4.437,4.437,0,0,0-1.35-3.132,4.6,4.6,0,0,0-6.52,0,4.435,4.435,0,0,0-1.35,3.132h2.434a.675.675,0,1,1,0,1.35h-2.44v1.8h2.44a.675.675,0,1,1,0,1.35Z",
    transform: "translate(-163.741 0)",
    fill: "#09c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscription);
export default __webpack_public_path__ + "static/media/transcription.5d59c21645334e32fe734c6b87609ab8.svg";
export { ForwardRef as ReactComponent };